import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactSelect from 'react-select';

import NotEnoughMoney from './NotEnoughMoney';

function getCompanyBlock(companies, company, selectCompany) {
    if(!companies.length || companies.length === 1) return false;

    return <div className="sw-alert__body" style={{marginTop: '20px',backgroundColor: '#f0f0f0', padding: '20px 15px'}}>
                <div style={{marginBottom:'15px'}}>
                    Оплатить со счёта компании?
                </div>
                <ReactSelect
                    wrapperStyle={{zIndex:9}}
                    name="form-field-name"
                    noResultsText="Список пуст"
                    placeholder="Счёт заказчика, без компании (выберите компанию)"
                    value={company}
                    onChange={(company) => selectCompany(company)}
                    clearable={false}
                    options={companies}
                />
            </div>
}

export default (props) => {

    const {
        inputProps,
        publish,
        totalPrice,
        selectCompany,
        companies,
        company,
        onCancel,
        onConfirm,
        isFetching,
        updating,
        currentUser,
        currentEmployee,
        disableConfirmButton,
    } = props;
    const {type, show, errorMessage} = inputProps;

    let title = "Сохранить в черновик?";
    let text = "После чего вы можете опубликовать его.";
    let isBalance = false;
    let isBalanceText = '';

    if(publish) {
        title = "Оплата заказа";
        text = "Сумма оплаты составляет " + (parseFloat(totalPrice)) + " р.";
    }

    if(type === "error") {
        title = "Ошибка";
    }

    if(type === "success") {
        title = publish ? "Заказ опубликован" : "Черновик сохранен";
    }

    if(company && company.value && parseInt(company.value) > 0 && currentEmployee.length) {     
        let user = currentEmployee[0];
        if(user.is_blocked) {
            isBalance = false;
            isBalanceText = "Вы блокированы администратором компании.";
        }
        else{
            isBalance = parseFloat(user.balance_limit - user.balance_used) >= parseFloat(totalPrice) ? true : false;
            isBalanceText = "Недостаточно средств. Вы превышаете лимит";
        }
    }
    else{
        isBalance = parseFloat(currentUser.balance_customer) >= parseFloat(totalPrice) ? true : false;
        isBalanceText = "Недостаточно средств на вашем счету"
    }

    return (
        <SweetAlert
            style={{overflow:'unset'}}
            type={type}
            confirmBtnCssClass={"alert-btn-confirm" + ((isFetching || updating || disableConfirmButton) ? " disabled" : "")}
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm={type === 'warning' ? true : false}
            show={show}
            confirmBtnText="Продолжить"
            cancelBtnText={type === 'warning' ? "Отменить" : "Закрыть"}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={title}
            onConfirm={() => {
                if(disableConfirmButton || updating || isFetching) return false;
                if((publish && isBalance) || !publish) {
                    onConfirm()
                }
            }}
            onCancel={onCancel}
        >
            <div>
                {
                    errorMessage && errorMessage.non_field
                    ?
                    <div style={{fontWeight:'bold', color:'red',marginBottom:'15px'}}>
                        {errorMessage.non_field}
                    </div>
                    :
                    <div>
                        <div style={{fontWeight:'bold'}}>{text}</div>

                        {
                            publish ?
                            company && parseInt(company.value) > 0 && currentEmployee.length ?
                            <div style={{marginTop: '10px', marginBottom:'10px', padding:'0 25px'}}>
                                <div>Дневной лимит компании: {currentEmployee[0].balance_limit} p.</div>
                                <div style={{marginTop:'5px'}}>На вашем счёту: {(currentEmployee[0].balance_limit - currentEmployee[0].balance_used)} p.</div>
                            </div>
                            :
                            <div style={{marginTop: '10px', marginBottom:'10px', padding:'0 25px'}}>
                                <div style={{marginTop:'5px'}}>На вашем счёту заказчика: {currentUser.balance_customer} p.</div>
                            </div>
                            : null
                        }

                        {
                            publish
                            ? getCompanyBlock(companies, company, selectCompany)
                            : null
                        }

                        <NotEnoughMoney 
                            publish={publish}
                            company={company}
                            isBalance={isBalance}
                            isBalanceText={isBalanceText}
                        />

                        {/*
                            publish && !isBalance && !company ?
                            <div>
                                <div className="not-enought-money">
                                    {isBalanceText}
                                </div>
                                <Link to='/account/balance'>
                                    Пополнить баланс
                                </Link>
                            </div>
                            : null
                        */}

                        {/*
                            publish && !isBalance && company ?
                            <div>
                                <div className="not-enought-money">
                                    {isBalanceText}
                                </div>
                                <Link to='/account/entity/balance'>
                                    Пополнить баланс компании
                                </Link>
                            </div>
                            : null
                        */}

                    </div>
                }
            </div>

        </SweetAlert>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/createOrderModal.js